import { render, staticRenderFns } from "./admin_user_detail.vue?vue&type=template&id=af9f8ee2&scoped=true&"
import script from "./admin_user_detail.vue?vue&type=script&lang=ts&"
export * from "./admin_user_detail.vue?vue&type=script&lang=ts&"
import style0 from "./admin_user_detail.vue?vue&type=style&index=0&id=af9f8ee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9f8ee2",
  null
  
)

export default component.exports